module.exports = __webpack_public_path__ + "static/img/3.10c6515c.png";